<template>
  <el-dialog
    title="Utilizatori"
    id="popup_dialog"
    :visible.sync="showPopup"
    class="my-dialog-class"
  >
    <el-form
      label-position="top"
      :inline="false"
      :rules="rules"
      label-width="100%"
      :model="selectedObject"
      ref="my-form"
      @submit.prevent="save"
      v-loading="loadingVisible"
    >
      <el-row :gutter="15">
        <el-col class="input-element">
          <el-form-item label="Tip utilizator" prop="TipUtilizator">
            <el-select
              @change="handleGroupGhange(selectedObject.TipUtilizator)"
              v-model="selectedObject.TipUtilizator"
              class="full-width"
              :disabled="mode == 'edit'"
            >
              <el-option label="Receptie" value="Receptie"></el-option>
              <el-option label="Mecanic" value="Mecanic"></el-option>
              <el-option label="Supervizor" value="Supervizor"></el-option>
              <el-option label="Management" value="Management"></el-option>
              <el-option label="Ajutor montator" value="AjutorMontator"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="selectedObject.TipUtilizator == 'Mecanic'" class="input-element">
          <el-form-item label="Ajutor montator" prop="IdAjutorMontator">
            <el-select
              v-model="selectedObject.IdAjutorMontator"
              class="full-width"
            >
              <el-option v-for="item in Info.ajutoriMontatori" :key="item.Id" :label="item.Nume" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col class="input-element">
          <el-form-item label="Nume" prop="Nume">
            <el-input class="full-width" v-model="selectedObject.Nume" />
          </el-form-item>
        </el-col>
        <el-col class="input-element">
          <el-form-item label="Email" prop="Email">
            <el-input class="full-width" v-model="selectedObject.Email" />
          </el-form-item>
        </el-col>        
        <el-col class="input-element">
          <el-form-item label="Bearer" prop="Bearer">
            <el-input class="full-width" v-model="selectedObject.Bearer"/>
          </el-form-item>
        </el-col>
        <el-col class="input-element" v-if="mode == 'add'">
          <el-form-item :label="labelPassword" prop="Parola">
            <el-input
              :type="typePassword"
              class="full-width"
              v-model="selectedObject.Parola"
            />
          </el-form-item>
        </el-col>
        <el-col class="input-element">
          <el-form-item label="Dezactivat">
            <el-checkbox
              class="full-width"
              v-model="selectedObject.Dezactivat"
              true-label="1"
              false-label="0"
            >
              Dezactivat
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col
          class="input-element"
          v-if="selectedObject.TipUtilizator == 'Mecanic'"
        >
          <el-form-item label="Centre productie" prop="CentreProductie">
            <el-select
              v-model="selectedObject.CentreProductie"
              multiple
              collapse-tags
              collapse-tags-tooltip
              placeholder="Alege"
              class="full-width"
            >
              <el-option
                v-for="item in Info.centreProductie"
                :key="'centre' + item.Id"
                :label="item.Nume"
                :value="item.Id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col v-if="selectedObject.TipUtilizator == 'Mecanic'" class="input-element">
          <el-form-item label="Interval pauza">
            <el-time-select
            style="margin-right: 15px"
              placeholder="Start pauza"
              v-model="selectedObject.InceputPauza"
              format="HH:mm"
              :picker-options="{
                start:'05:00',
                step:'00:05', 
                end:'22:00',
              }"
            >
            </el-time-select>

            <el-time-select
              placeholder="Sfarsit pauza"
              v-model="selectedObject.SfarsitPauza"
              format="HH:mm"
              :picker-options="{
                start: '05:00',
                step: '00:05',
                end: '22:00' ,
                minTime: selectedObject.InceputPauza != undefined ? selectedObject.InceputPauza : ''
              }"
            >
            </el-time-select>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="danger"
        @click="reset_password()"
        v-if="$has_right('Management') && mode === 'edit'"
      >
        Schimba parola
      </el-button>

      <el-button @click="showPopup = false"> Renunta </el-button>
      <el-button type="primary" @click="save"> Salveaza </el-button>
    </span>
    <NewPassword ref="reset-password-dlg" />
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import NewPassword from "@/pages/Admin/NewPassword.vue";

export default {
  name: "Utilizatori_dialog",
  extends: BasePage,
  components: {
    NewPassword,
  },
  data() {
    var checkPass = (rule, value, callback) => {
      if (value == undefined || value == "" || value.length <= 0) {
        callback(new Error("Campul este obligatoriu"));
      } else {
        let base = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z\d\W_]{8,32}$/;
        if (!value.match(base)) {
          callback(
            new Error(
              "Parola trebuie sa aiba intre 8 si 32 caractere, o litera mare, o litera mica, o cifra si un caracter special"
            )
          );
        } else {
          callback();
        }
      }
    };

    var checkPin = (rule, value, callback) => {
      if (value == undefined || value == "" || value.length <= 0) {
        callback(new Error("Campul este obligatoriu"));
      }
    };
    return {
      showPopup: false,
      validatorPass: checkPass,
      validatorPin: checkPin,
      mode: "add",
      labelPassword: "Parola",
      typePassword: "text",
      mecanicMode: false,
      selectedObject: {
        Nume: "",
        Email: "",
        Parola: "",
        IdGrupDrepturi: "",
        CentreProductie: "",
        Bearer: "",
      },
      Info: {
        rights_groups: [],
        centreProductie: [],
        ajutoriMontatori: [],
      },
      rules: {
        //   Nume: [ { required: true, message: "Campul este obligatoriu" } ]
        Nume: [{ required: true, message: "Campul este obligatoriu" }],
        Email: [{ required: true, message: "Campul este obligatoriu" }],
        Bearer: [{ required: true, message: "Campul este obligatoriu" }],
        Parola: [{ required: true, validator: checkPass, trigger: ["change", "blur"] }],
        TipUtilizator: [{ required: true, message: "Campul este obligatoriu" }],
      },
    };
  },

  methods: {
    handleGroupGhange: async function (group) {
      console.log("schimbat grupul", group);
      console.log("mecanicMode", this.mecanicMode);
      if (group === "Mecanic") {
        this.typePassword = "number";
        this.labelPassword = "Pin";
        this.rules.Email[0].required = false;
        this.mecanicMode = true;
        this.rules.Parola[0] = {
          required: true,
          min: 4,
          message: "Pin-ul trebuie sa fie de cel putin 4 cifre",
        };
      } else {
        if (this.mecanicMode === true) {
          this.rules.Email[0].required = true;
          this.labelPassword = "Parola";
          this.rules.Parola[0] = [
            { validator: this.validatorPass, trigger: ["change", "blur"] },
          ];
        }
      }
    },
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },

    reset_password() {
      this.$refs["reset-password-dlg"].show_me(this.selectedObject, "reset");
    },

    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.selectedObject.Nume = "";
        this.selectedObject.Email = "";
        this.selectedObject.Parola = "";
        this.selectedObject.CentreProductie = [];
      } else {
        this.mode = "edit";
        var result = await this.post("utilizatori/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
        this.Info.ajutoriMontatori = result.ajutori_montatori;
      }
    },
    async get_info() {
      var response = await this.post("utilizatori/get_info_for_dialog");
      this.Info.rights_groups = response.rights_groups;
      this.Info.centreProductie = response.centreProductie;
    },
    save: async function () {
      this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          await this.post("utilizatori/save", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.selectedObject= {};
          this.$emit("save");
        }
      });
    },
  },
  mounted: function () {
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}

.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  width: 100%;
}
</style>